import { RefiChariot } from './chariot.component.js';
import '../../lit-element.js';
import '../../unsafe-html.js';
import '../../directive.js';

customElements.define('refi-common-chariot', RefiChariot);
